import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ensurePermissions } from '@/hooks/usePermissions';

const myStylesSearch = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
  /** Active sub-section on the detail overview tab (`general` | `ecoFootprint`). */
  section: z.string().optional(),
});

export const Route = createFileRoute('/(client)/my-styles/(pages)')({
  validateSearch: myStylesSearch,

  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.styles.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (
      location.pathname === '/my-styles' ||
      location.pathname === '/my-styles/'
    ) {
      throw redirect({ to: '/my-styles/styles/active' });
    }
  },
});
